module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/315a5675d1738c029b0f55817c249627.png";